import * as React from "react";
import {FC, useEffect} from "react";
import {useFormContext} from "react-hook-form";
import {Grid} from "@mui/material";
import {BrickBox} from "../../BrickMailType";
import {FormInputText} from "../../../../shop/wholesale/form/FormInputText";
import {FormInputColor} from "../../../../shop/wholesale/form/FormInputColor";
import {FormInputSelect} from "../../../../shop/wholesale/form/FormInputSelect";
import {alignments} from "../../constants/MailConstants";

export const BrickBoxEditor: FC<{ brick: BrickBox, onChange: (brick: BrickBox) => void }> = ({brick, onChange}) => {
  const formContext = useFormContext<BrickBox>();
  const {reset, control} = formContext;

  useEffect(() => {
    reset(brick)
  }, [brick, reset])

  return (
    <div>
      <Grid container spacing={"10px"}>
        <Grid item xs={12}>
          <FormInputText name={"value"} label={"Button text"}/>
        </Grid>
        <Grid item xs={4}>
          <FormInputColor name={"color"} control={control} label={"Button text color"} defaultColor={"#FFFFFF"}/>
        </Grid>
        <Grid item xs={4}>
          <FormInputColor name={"backgroundColor"} control={control} label={"Button background color"}
                          defaultColor={"#993300"}/>
        </Grid>
        <Grid item xs={4}>
          <FormInputColor name={"borderColor"} control={control} label={"Button border color"}
                          defaultColor={"#993300"}/>
        </Grid>
        <Grid item xs={4}>
          <FormInputText name={"margin"} control={control} label={"Margin"}/>
        </Grid>
        <Grid item xs={4}>
          <FormInputText name={"fontSize"} control={control} label={"Font size"}/>
        </Grid>
        <Grid item xs={4}>
          <FormInputText name={"fontFamily"} control={control} label={"Font"}/>
        </Grid>
        <Grid item xs={6}>
          <FormInputSelect name={"align"} control={control} label={"Align"} options={alignments}/>
        </Grid>
        <Grid item xs={12}>
          <FormInputText name={"activation"} control={control} label={"Activation expression"}/>
        </Grid>
      </Grid>
    </div>
  );
}